var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcItems(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.85712H9V8.85712H5V10.8571H9V14.8571H11V10.8571H15V8.85712H11V4.85712ZM10 -0.142883C4.49 -0.142883 0 4.34712 0 9.85712C0 15.3671 4.49 19.8571 10 19.8571C15.51 19.8571 20 15.3671 20 9.85712C20 4.34712 15.51 -0.142883 10 -0.142883ZM10 17.8571C5.59 17.8571 2 14.2671 2 9.85712C2 5.44712 5.59 1.85712 10 1.85712C14.41 1.85712 18 5.44712 18 9.85712C18 14.2671 14.41 17.8571 10 17.8571Z",
    fill: "#646C77"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcItems);
export default __webpack_public_path__ + "static/media/ic_items.8b95b92cc243b2cae917cf10c90683ef.svg";
export { ForwardRef as ReactComponent };